import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import { EmptyRecord } from "../../utils/PageUtility";
import RecordPagination from "../../utils/RecordsPagination";
import moment from "moment";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";

import { appHelpers } from "../../_helpers";


const CustomTableCell = withStyles(theme => ({
    head: {
        color: "#04137b",
        fontSize: "14px",
        fontWeight: "lighter"
    },
    icon:{
        margin: "8px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  icon: {
    margin: "8px 0px 8px 8px",
    position: "relative",
    top: "7px",
    paddingLeft: "8px",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  tableStyle: {
    padding: 0,
  },
};

const TableStructure = ({ classes, records, pageIndex }) => {
  return (
    <Table className={classes.table} aria-labelledby="tableTitle">
      <TableHead >
        <TableRow>
          <CustomTableCell>S/N</CustomTableCell>
          <CustomTableCell>Date</CustomTableCell>
          <CustomTableCell>Exchange Rate</CustomTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {records &&
          records.map((item, key) => {
            return (
              <TableRow hover key={key}>
                <TableCell>{pageIndex + key}</TableCell>
                <CustomTableCell component="th">
                  <div>{moment(item.EffectiveDate).format("YYYY-MM-DD")}</div>
                </CustomTableCell>
                <CustomTableCell component="th">
                  <div> &#8358; {appHelpers.numberWithCommas(item.Rate)}</div>
                </CustomTableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};

class AirlineViewTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false,
      airlines: [],
    };
  }

  render() {
    const {
      classes,
      totalCounts,
      fetchMore,
      filterUsers,
      currentPage,
      pageSize,
      user,
      records,
      handleSearch,
    } = this.props;

    if (totalCounts === 0)
      return <EmptyRecord message={"No Exchange Rate Yet!"} />;
    const pageIndex = pageSize * (currentPage - 1) + 1;

    return (
      <div>
        <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
          <RecordPagination
            fetchMore={fetchMore}
            totalCount={totalCounts}
            pageSize={pageSize}
            currentPage={currentPage}
            target={
              <TableStructure
                pageIndex={pageIndex}
                records={records}
                pageSize={pageSize}
                currentPage={currentPage}
                classes={classes}
                filterUsers={filterUsers}
                handleSearch={handleSearch}
                user={user}
              />
            }
          />
        </div>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(AirlineViewTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/ExchangeRateAirline/airlineViewTable.js